<template>
    <div class='page'>
        <van-empty image="error" :description="message" />
    </div>
    
</template>
<script>
import {Empty} from 'vant';
import env from '@/utils/env'



export default {
        name: "epindex",
        components:{
           [Empty .name]:Empty,
        },
        data(){
            return {
                code: 1,
                code: '',
                message: "发表你的精彩评论~",
            }
        },
        computed: {
          
        },
        watch: {
            
        },
        created() {
            //this.onPlayerPlay(this.$refs.videoPlayer.player)
            
        },
        
        mounted() {
          this.code = this.util.getQueryStr('code');
          this.redirectUrl = this.util.getQueryStr('redirectUrl');
          if(this.code=='501'){
              this.message ='未设置对应的企业应用'
          }
          if(this.code=='503'){
            // 走微信授权
            location.href= '/mini/login/uniform_platform'+'?token='+this.util.token+'&redirect='+encodeURIComponent( this.redirectUrl);
          }
        },
        methods:{
          
        }
    }

</script>

<style scoped>

.comment_input_box {
  position: fixed;
  bottom:0px;
  /* top:0px; */
  opacity:1;
  z-index: 2999;
  width: 100%;
  border-top: 1px solid #585858;
  background: #1F1F21;
  padding: 10px 15px;
  box-sizing: border-box;
  display: flex;
}
.comment_input{
  flex: 1;
  background: #353539;
  color: #fff;
  border-radius: 16px;
  height: 36px;
  border: none;
  padding-left: 10px;
}
.comment_input_right{
  width: 36px;
  text-align: center;
}
.comment_i{
  font-size: 22px;
  line-height: 36px;
  color: #999;
  transition: .3s;
}
.comment_i_active {
  color: #f44;
}
.comment_input_box2{
  background-color: #1F1F21;
  padding: 10px 15px;
}
</style>